import React from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import Card from "./Card";

import "./Resume.css";

export default function Resume() {
  const programmingSkillDetails = [
    { skill: "HTML5", ratingPercentage: 90 },
    { skill: "CSS3", ratingPercentage: 90 },
    { skill: "JavaScript", ratingPercentage: 80 },
    { skill: "React", ratingPercentage: 75 },
    { skill: "Recat Redux", ratingPercentage: 70 },
    { skill: "Recat Hooks", ratingPercentage: 75 },
    { skill: "React Router", ratingPercentage: 80 },
    { skill: "Firebase and Firestore", ratingPercentage: 70 },
    { skill: "Bootstrap", ratingPercentage: 80 },
    { skill: "Matiral UI", ratingPercentage: 85 },
    { skill: "Git and GitHub", ratingPercentage: 90 },
    { skill: "Microsoft Office", ratingPercentage: 90 },
  ];

  const projectsDetails = [
    {
      cardName: "Online Shopping Store",
      cardDescription: "An online shopping store for selling clothes",
      cardImage: "https://i.ibb.co/ZLJwX58/oss-min.jpg",
      cardTech: "HTML5, CSS3, SASS, React, Redux, Firebase, Firestore, Stripe",
      cardLink: "https://online-store-puce.vercel.app/",
      cardRepo: "https://github.com/DevMonzer/Online-Shopping-Store",
    },
    {
      cardName: "Movies App",
      cardDescription: "Check out the latest movies!",
      cardImage: "https://i.ibb.co/8P0PJwq/movies-min.jpg",
      cardTech:
        "React, Redux Toolkit, React Router, TMDB API, Alan app for AI voice",
      cardLink: "https://movies-show.vercel.app/",
      cardRepo: "https://github.com/DevMonzer/Movies",
    },
    {
      cardName: "Series App",
      cardDescription: "Check out the latest tv shows!",
      cardImage: "https://i.ibb.co/z7fn6GZ/series-min.jpg",
      cardTech:
        "React, Redux Toolkit, React Router, TMDB API, Alan app for AI voice",
      cardLink: "https://series-devmonzer.vercel.app/",
    },
    {
      cardName: "YouTube Clone",
      cardDescription: "A clone app to watch YouTube videos",
      cardImage: "https://i.ibb.co/4PrLNqB/Capture.jpg",
      cardTech: "React JavaScript, MUI, Rapid APIs, YouTube V3 API",
      cardLink: "https://youtube-clone-poz2.onrender.com/",
      cardRepo: "https://github.com/DevMonzer/YouTube-Clone",
    },
    {
      cardName: "Nexter",
      cardDescription: "A landing page for selling luxery houses",
      cardImage: "https://i.ibb.co/xSP9jDG/nexter-min.jpg",
      cardTech: "HTML5, CSS3, Advanced CSS3 Grid System, SASS",
      cardLink: "https://devmonzer.github.io/Nexter/",
      cardRepo: "https://github.com/DevMonzer/Nexter",
    },
    {
      cardName: "Raha",
      cardDescription: "A landing page for Corinthia Khartoum hotel",
      cardImage: "https://i.ibb.co/X5FrJFB/raha-min.jpg",
      cardTech: "HTML5, CSS3, Advanced CSS3 Flexbox, SASS",
      cardLink: "https://devmonzer.github.io/Raha/",
      cardRepo: "https://github.com/DevMonzer/Raha",
    },
    {
      cardName: "Natours",
      cardDescription:
        "A landing page for renting adventures tours for adventures people",
      cardImage: "https://i.ibb.co/tXZq66L/nature-min.jpg",
      cardTech: "HTML5, CSS3, SASS, Advanced Animations",
      cardLink: "https://devmonzer.github.io/Natours/",
      cardRepo: "https://github.com/DevMonzer/Natours",
    },
    {
      cardName: "Mapty",
      cardDescription:
        "Mapty app uses a third party service to render a map to track your workouts",
      cardImage: "https://i.ibb.co/yqhT5rZ/mapty-min.jpg",
      cardTech: "HTML5, CSS3, JavaScript, Leaflet Library",
      cardLink: "https://map-app-zeta.vercel.app/",
      cardRepo: "https://github.com/DevMonzer/Map-App",
    },
    {
      cardName: "Feedback App",
      cardDescription:
        "A feedback app is an app that allows you to send a feedback",
      cardImage: "https://i.ibb.co/QpP4dsw/Capture.jpg",
      cardTech: "HTML5, CSS3, React, Framer Motion",
      cardLink: "https://feedbackappp.netlify.app/",
      cardRepo: "https://github.com/DevMonzer/Feedback-App",
    },
    {
      cardName: "Recipes",
      cardDescription:
        "This is a react app to list recipes. It allows users to create, update, and delete recipes",
      cardImage: "https://i.ibb.co/0fFxc73/recipe-min.jpg",
      cardTech: "HTML5, CSS3, React",
      cardLink: "https://recipes-app-sigma-pearl.vercel.app/",
      cardRepo: "https://github.com/DevMonzer/Recipes-App",
    },
    {
      cardName: "QR Code Generator",
      cardDescription:
        "Simple app to generate and download a QR code that can be used to share a link",
      cardImage: "https://i.ibb.co/ZcDZzmJ/Capture-min-1.jpg",
      cardTech: "HTML5, Tailwind CSS, JavaScript",
      cardLink: "https://devmonzer.github.io/QR-Code-Generator/",
      cardRepo: "https://github.com/DevMonzer/QR-Code-Generator",
    },
  ];

  const educationDetails = [
    {
      cardName: "National Ribat University",
      cardDescription: "2014 - 2018",
      cardImage: "https://i.ibb.co/7QMrh90/nru-min.jpg",
      cardTech:
        "Bachelor's degree in Computer Science with 3.54/4.00 GPA = 90%",
      cardLink: "http://ribat.edu.sd/homepage",
      cardRepo: "",
    },
    {
      cardName: "Udemy",
      cardDescription: "2018 - now",
      cardImage: "https://i.ibb.co/qmWsK4y/udemy-min.jpg",
      cardTech:
        "Studying programming, IT support specialist, and web development courses.",
      cardLink: "https://www.udemy.com/",
      cardRepo: "",
    },
    {
      cardName: "Zero To Mastery Academy",
      cardDescription: "2018 - now",
      cardImage: "https://i.ibb.co/wQQphgh/ztm-min.jpg",
      cardTech: "Studying programming and web development courses.",
      cardLink: "https://zerotomastery.io/",
      cardRepo: "",
    },
  ];

  const resumeDetails = [
    <div>
      <div className='line'></div>
      <div className='resume-container-education' key='education'>
        <p className='resume-header'>Education</p>
        <Card cardDetails={educationDetails} text='Visit the website' />
      </div>

      <div className='line'></div>
      <div key='work-experience'>
        <p className='resume-header'>Work History</p>
        <div className='resume-main-heading'>
          <div className='resume-details'>
            <span className='resume-sub-heading'>Freelancer</span>
            <p className='resume-sub-heading'> 2018 - 2021 </p>
          </div>
          <div className='resume-sub-heading'>
            <span>Frontend Developer</span>
          </div>
        </div>
        <div className='experience-description'>
          <p className='resume-description-text'>
            Working on a range of projects, developing and structuring websites
            and interacting on a daily basis with web developers, developing
            frontend functionality of sites.
          </p>
        </div>
        <div className='experience-description'>
          <span className='resume-description-text'>
            - Developing new user-facing features, determining the structure and
            design of web pages.
          </span>
          <br />
          <span className='resume-description-text'>
            - Creating React JavaScript components using advanced HTML5 and CSS3
            designs.
          </span>
          <br />
          <span className='resume-description-text'>
            - Analyzing user needs to determine technical requirements.
          </span>
          <br />
          <span className='resume-description-text'>
            - Ensuring web design is optimized for smartphones.
          </span>
          <br />
          <span className='resume-description-text'>
            - Building reusable code for future use.
          </span>
          <br />
          <span className='resume-description-text'>
            - Optimizing web pages for maximum speed and scalability.
          </span>
        </div>
      </div>

      <div className='line'></div>
      <div key='programming-skills'>
        <p className='resume-header'>Programming Skills</p>
        <div className='programming-skills-container' key='programming-skills'>
          {programmingSkillDetails.map((skill, index) => (
            <div className='skill-parent' key={index}>
              <div className='heading-bullet'></div>
              <span className='skill-title'>{skill.skill}</span>
              <div className='skill-percentage'>
                <div
                  style={{ width: skill.ratingPercentage + "%" }}
                  className='active-percentage-bar'
                ></div>
                <span className='skill-percentage-text'>
                  {skill.ratingPercentage}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='line'></div>
      <div className='resume-container-projects' key='projects'>
        <p className='resume-header'>Projects</p>
        <Card cardDetails={projectsDetails} text='Watch Live' />
      </div>

      <div className='line'></div>
      <div key='interests'>
        <p className='resume-header'>Interests</p>
        <div className=' resume-container-interests-parent' key='interests'>
          <div className='resume-container-interests'>
            <div className='resume-main-heading'>
              <div>
                <span>Reading Books</span>
              </div>
            </div>
            <div className='resume-heading'>
              <div className='resume-main-heading'>
                <div>
                  <span>Learning Languages</span>
                </div>
              </div>
            </div>
            <div className='resume-heading'>
              <div className='resume-main-heading'>
                <div>
                  <span>Watching Documentery Movies</span>
                </div>
              </div>
            </div>
            <div className='resume-heading'>
              <div className='resume-main-heading'>
                <div>
                  <span>Football</span>
                </div>
              </div>
            </div>
            <div className='resume-heading'>
              <div className='resume-main-heading'>
                <div>
                  <span>Video Games</span>
                </div>
              </div>
            </div>
            <div className='resume-heading'>
              <div className='resume-main-heading'>
                <div>
                  <span>Chess</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='line'></div>
    </div>,
  ];

  const getResumeScreen = () => {
    return (
      <div>
        {resumeDetails.map((resumeDetail) => (
          <div key={Math.random() * 10}>{resumeDetail}</div>
        ))}
      </div>
    );
  };

  return (
    <div className='resume-container screen-container' id='resume'>
      <div className='resume-content'>
        <ScreenHeading title={"Resume"} subHeading={"My Formal Bio Details"} />
        <div className='resume-card'>
          <div className='resume-bullet-details'>{getResumeScreen()}</div>
        </div>
      </div>
    </div>
  );
}
